export interface StoreRating {
  store: "play" | "apple";
  rating: number; // out of 5
  reviewCount: number;
  reviewsUrl: string;
}

// TODO(backend): populate via the scheduled Cloud Function once the app is
// actually published and has real store ratings (see ZP-97's tech stack —
// a build-time fetch from the public store listings). `null`, not a
// plausible-looking placeholder number: a fabricated star rating is a
// specific, checkable false trust claim, unlike an inert placeholder link.
// AppDownloadSection.tsx shows nothing extra while this is null.
export const APP_RATINGS: StoreRating[] | null = null;

// The threshold ZP-97's AC4 wants marketing flagged below, once real ratings
// exist and this repo has a CI step that can act on it — not enforced here.
export const RATING_ALERT_THRESHOLD = 4.0;
